import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { KeyRound, Mail, Lock } from "lucide-react";

interface AccessStepProps {
  form: UseFormReturn<any>;
}

const AccessStep = ({ form }: AccessStepProps) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold flex items-center gap-2">
          <KeyRound className="w-6 h-6 text-primary" />
          Accessi
        </h2>
        <p className="text-muted-foreground">
          Inserisci le credenziali del tuo account Facebook per consentirci di gestire le campagne
        </p>
      </div>

      <FormField
        control={form.control}
        name="facebookEmail"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              Email *
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="esempio@email.com" autoComplete="off" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="facebookPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Lock className="w-4 h-4" />
              Password *
            </FormLabel>
            <FormControl>
              <Input type="password" placeholder="••••••••" autoComplete="new-password" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default AccessStep;
